import { render, staticRenderFns } from "./transferlist.vue?vue&type=template&id=782b6fea"
import script from "./transferlist.vue?vue&type=script&lang=js"
export * from "./transferlist.vue?vue&type=script&lang=js"
import style0 from "./transferlist.vue?vue&type=style&index=0&id=782b6fea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports